import { render } from "./CreateLiquidation1.vue?vue&type=template&id=e2a0ec78"
import script from "./CreateLiquidation1.vue?vue&type=script&lang=js"
export * from "./CreateLiquidation1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__